import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';
import { HelperService } from '../../services/helper/helper.service';

@Pipe({
  name: 'contentInformation'
})
export class InformationPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.InformationEntry {
    if (!entry || (!entry.files && !entry.title && (!entry.detail || Object.keys(entry.detail).length === 0)) || !this.contentService.isValid(entry)) {
      return null;
    }

    const informationEntry = new Models.InformationEntry();

    let media = this.contentService.getMediaEntriesForEntry(entry?.getId?.() || entry?._id);
    if (entry?.related?.entries?.length === 1) {
      const related = this.contentService.getEntry(entry.related.entries[0].id);
      entry.detail = { ...related.detail, ...entry.detail };
      if (!entry?.files?.length && !!related?.files?.length) {
        media = this.contentService.getMediaEntriesForEntry(related?.getId?.() || related?._id);
      }
    }

    const raw = HelperService.parseJSON(entry.detail.raw);

    informationEntry.populateFromJSON({
      sourceId: entry._id, title: entry.title, documents: this.contentService.getDocumentEntriesForEntry(entry?.getId?.() || entry?._id),
      iFrameUrl: entry?.detail?.iFrameUrl || raw?.iFrameUrl || null, website: entry?.detail?.website, media
    });

    informationEntry.description = entry?.detail?.description || informationEntry.description;

    if (entry?.detail?.website && !informationEntry.description && !informationEntry.documents.length && !informationEntry.media.length && !informationEntry.bookable && !informationEntry.bookingUrl) {
      informationEntry.iFrameUrl = entry.detail.website;
    }

    if (entry?.detail?.location) {
      const l = entry.detail.ocation;
      Object.assign(informationEntry, {
        street: l?.address, city: l?.city, zip: l?.zip, latitude: l?.coordinates?.latitude, longitude: l?.coordinates?.longitude,
      });
    }
    if (entry?.detail?.bookable && entry?.detail?.bookingUrl) {
      informationEntry.bookable = entry.detail.bookable;
      informationEntry.bookingUrl = entry.detail.bookingUrl;
      informationEntry.bookingText = entry.detail.bookingTextScreen || entry.detail.bookingText;
    }
    if (entry?.detail?.contact?.[0]?.variants && Array.isArray(entry.detail.contact[0].variants)) {
      informationEntry.phone = entry.detail.contact[0].variants.find(e => e.type === 'phone')?.value || informationEntry.phone;
      informationEntry.fax = entry.detail.contact[0].variants.find(e => e.type === 'fax')?.value || informationEntry.fax;
      informationEntry.email = entry.detail.contact[0].variants.find(e => e.type === 'email')?.value || informationEntry.email;
    }
    return informationEntry;
  }
}
